import { render } from "./JiaGongZhiJianPage.vue?vue&type=template&id=4924b3df&scoped=true"
import script from "./JiaGongZhiJianPage.vue?vue&type=script&lang=js"
export * from "./JiaGongZhiJianPage.vue?vue&type=script&lang=js"

import "./JiaGongZhiJianPage.vue?vue&type=style&index=0&id=4924b3df&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4924b3df"]])

export default __exports__